import {useContext} from 'react';
import {MessageDisplayerUtility} from "../MessageDisplayerUtility";
import {LeaveWithoutSavingWarningUtility} from "../LeaveWithoutSavingWarningUtility";
import {GlobalContext} from "../../admin-frame/AdminFrame";
import {useRenderableData} from "./useRenderableData";

// Engine for a wrapper component for a form, where wrapper is in charge of creating models defined by the form
export function useModelCreateEngine(
    modelCreateApiFunction,
    modelName,
    createCallback
) {
    const context = useContext(GlobalContext);
    const initialState = {loading: false};
    const createEngineRenderableData = useRenderableData(initialState)

    function createModel(formModelData) {
        createEngineRenderableData.updateAndRender({loading: true})
        modelCreateApiFunction(formModelData)
            .then((response) => {
                LeaveWithoutSavingWarningUtility.disableLeaveWithoutSavingWarnings(context);
                MessageDisplayerUtility.success(`Successfully created ${modelName}.`);
                if (createCallback) {
                    createCallback(response.id);
                }
            })
            .catch((error) => {
                createEngineRenderableData.updateAndRender({loading: false})
                console && console.log(error);
                MessageDisplayerUtility.error(`An error occurred while creating the ${modelName}.`);
            })
    }

    return {
        renderableData: createEngineRenderableData,
        createModel: createModel,
    };
}
